module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.formValue,
      "fields": _vm.fields,
      "model": "switches"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13d687d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/ServerSwitchForm.vue
// module id = 974
// module chunks = 2